module.exports = __webpack_public_path__ + "img/hint_icon.3f95bd70.svg";